import React from 'react';

class KeycloakAuthContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = { isAuthenticated: false };
  }

  async componentDidMount() {
    const {
      disabled,
      userStore: { auth, authenticated, tryAuthenticated, disabledUser },
    } = this.props;

    if (!(disabled || disabledUser)) {
      if (!auth && !authenticated) {
        const isAuthenticated = await tryAuthenticated();
        this.setState({ isAuthenticated });
      }
    }
  }

  render() {
    const ViewComponent = this.props.viewComponent;

    const {
      disabled,
      userStore: { disabledUser },
    } = this.props;

    const viewComponentProps = {
      isAuthenticated: this.state.isAuthenticated,
      disabled: disabled || disabledUser,
      history: this.props.history,
      location: this.props.location,
      match: this.props.match,
    };

    return <ViewComponent {...viewComponentProps} />;
  }
}
export default KeycloakAuthContainer;
